import type { OnInit } from '@angular/core';
import { afterNextRender, Component, inject, isDevMode } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { HeaderComponent } from './frontend/common/header/header.component';
import { FooterComponent } from './frontend/common/footer/footer.component';
import { MessageService } from '@pct-ng/feature-message-material';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { removeSplashScreen } from './remove-splashscreen';
import { UpdateService } from './core/pwa/update.service';
import { AutoSubscribePushNotificationService } from './core/pwa/push-notification/auto-subscribe-push-notification.service';
import { filter } from 'rxjs';
import { InstallableService } from './core/pwa/installable/installable.service';

@Component({
  imports: [RouterModule, HeaderComponent, FooterComponent],
  selector: 'app-root',
  template: `
    <main>
      <app-header />
      <div class="mt-[84px]"><router-outlet /></div>
    </main>
    <app-footer />
  `,
  host: { class: 'block min-h-screen flex flex-col justify-between' },
})
export class AppComponent implements OnInit {
  readonly #document = inject(DOCUMENT);
  #router = inject(Router);
  #route = inject(ActivatedRoute);

  constructor() {
    // Start service
    inject(MessageService);
    inject(MatIconRegistry).addSvgIconSet(
      inject(DomSanitizer).bypassSecurityTrustResourceUrl('./pct.symbol.svg'),
    );
    if (!isDevMode()) {
      inject(UpdateService);
      inject(AutoSubscribePushNotificationService);
      inject(InstallableService);
    }

    afterNextRender(() => removeSplashScreen(this.#document));
  }

  ngOnInit(): void {
    this.#router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      let currentRoute = this.#route.root;

      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      }

      const bodyClass = currentRoute.snapshot.data['bodyClass'];

      this.#document.body.className = '';
      if (bodyClass) {
        this.#document.body.classList.add(bodyClass);
      }
    });
  }
}
